//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { userEntSavePasswordApi } from '@/api/user';
export default {
  name: 'DialogForm',
  components: {},
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      loading: false,
      tableFrom: {
        password: '',
        password_confirm: ''
      },
      rules: {
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        password_confirm: [{
          required: true,
          message: '请输入确认密码',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    handleClose: function handleClose() {
      this.dialogFormVisible = false;
      var userInfo = this.$store.state.user.userInfo;
      userInfo.is_init = 0;
      this.$store.commit('user/SET_USERINFO', userInfo);
    },
    handleOpen: function handleOpen() {
      this.dialogFormVisible = true;
    },
    // 提交
    handleConfirm: function handleConfirm() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.tableFrom.phone = _this.$store.state.user.userInfo.phone;
          _this.savePassword(_this.tableFrom);
        }
      });
    },
    savePassword: function savePassword(data) {
      var _this2 = this;
      this.loading = true;
      userEntSavePasswordApi(data).then(function (res) {
        if (res.status == 200) {
          _this2.loading = false;
          _this2.handleClose();
        }
      }).catch(function (error) {
        _this2.loading = false;
      });
    }
  }
};